const monthMap = {
  0: 'januar',
  1: 'februar',
  2: 'mars',
  3: 'april',
  4: 'mai',
  5: 'juni',
  6: 'juli',
  7: 'august',
  8: 'september',
  9: 'oktober',
  10: 'november',
  11: 'desember'
};
export const createNorwegianDateStringWithTime = date => {
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const hours = date.getHours();
  const day = date.getDate();
  const month = monthMap[date.getUTCMonth()];
  const year = date.getFullYear().toString();
  return `${day}. ${month}, ${year}, kl. ${hours}:${minutes}`;
};
//# sourceMappingURL=createStringDate.js.map